import { BgColorType } from "@/lib/main";
import { CSSProperties, PropsWithChildren } from "react";

type Props = PropsWithChildren<{
  bgColor?: BgColorType;
  id?: string;
  style?: CSSProperties;
  striped?: boolean;
  index?: number;
  bgColorAlternate?: BgColorType; // used when striped is true
}>;

export default function TR({
  children,
  id,
  bgColor,
  bgColorAlternate,
  style,
  striped,
  index,
}: Props) {
  const getBackgroundColor = () => {
    // Striped mode: alternate between bgColor (odd) and bgColorAlternate (even)
    if (striped && index !== undefined) {
      if (index % 2 === 0 && bgColorAlternate) {
        return `var(--color-background-${bgColorAlternate})`;
      }
      if (index % 2 === 1 && bgColor) {
        return `var(--color-background-${bgColor})`;
      }
    }

    // Non-striped: just use bgColor if provided
    if (bgColor) return `var(--color-background-${bgColor})`;

    return undefined;
  };

  const styles: CSSProperties = {
    backgroundColor: getBackgroundColor(),
    ...style,
  };

  return (
    <tr id={id} style={styles}>
      {children}
    </tr>
  );
}
